<template>
  <v-container fluid>
    <v-main>
      <v-row
        align="center"
        justify="center"
        class="h-screen"
      >
        <v-col
          cols="11"
          sm="5"
          md="5"
          lg="3"
          class="text-center"
        >
          <img
            :src="require('@/assets/bizmates.svg')"
            alt="Bizmates"
            class="mb-3"
          >
          <h1 class="text-h2 font-weight-light mb-3">
            Error 4<span>&#9785;</span>4
          </h1>
          <div class="text-body-1 text-left">
            <p class="mb-3">
              Sorry, but the page you were trying to view does not exist.
            </p>
            <p>It looks like this was the result of either:</p>
            <v-container>
              <v-col>
                <v-row>
                  <ul>
                    <li>a mistyped address</li>
                    <li>an out-of-date link</li>
                  </ul>
                </v-row>
              </v-col>
            </v-container>

            <v-row>
              <v-spacer />
              <v-btn
                href="/"
                color="light-blue-darken-2"
                variant="text"
                rounded
              >
                Back to home
              </v-btn>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-main>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      //
    };
  },
};
</script>
